// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumbs":"Breadcrumbs_Breadcrumbs__AcSGW","selected":"Breadcrumbs_selected__2PtXE"};